import React from "react";
import { Link, useLocation } from "react-router-dom";

import NotificationUnreadBadge from "../notifications/NotificationUnreadBadge";
import { InvestorSectionIcon } from "./InvestorMetricIcons";
import useNotificationUnreadCount from "../../hooks/useNotificationUnreadCount";
import { INVESTOR_SIDEBAR_NAV, isSharesManagementRoute } from "../../utils/investorNavConfig";

function linkActive(pathname, to) {
  const pathOnly = String(to).split("?")[0];
  if (pathOnly === "/investments") {
    return isSharesManagementRoute(pathname);
  }
  if (pathOnly.startsWith("/my-history")) {
    return pathname.startsWith("/my-history") || pathname === "/transactions";
  }
  return pathname === pathOnly;
}

export default function InvestorSidebarNav() {
  const { pathname } = useLocation();
  const { unreadCount } = useNotificationUnreadCount();

  return (
    <nav className="app-nav app-nav-vertical investor-sidebar-nav" aria-label="Investor navigation">
      {INVESTOR_SIDEBAR_NAV.map((item) => {
        const active = linkActive(pathname, item.to);
        const isNotifications = item.to === "/notifications";
        const showUnread = isNotifications && unreadCount > 0;
        return (
          <Link
            key={item.to}
            className={[
              "nav-link",
              active ? "nav-link--active" : "",
              showUnread ? "nav-link--has-unread" : "",
            ]
              .filter(Boolean)
              .join(" ")}
            to={item.to}
            aria-current={active ? "page" : undefined}
          >
            {item.icon ? (
              <span className="nav-link__icon" aria-hidden>
                <InvestorSectionIcon name={item.icon} />
              </span>
            ) : null}
            <span className="nav-link__label">{item.label}</span>
            {showUnread ? (
              <NotificationUnreadBadge count={unreadCount} className="nav-link__unread-badge" />
            ) : null}
          </Link>
        );
      })}
    </nav>
  );
}
